import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import CustomersPage from "@/pages/CustomersPage";
import CustomerDetailPage from "@/pages/CustomerDetailPage";
import ProjectPage from "@/pages/ProjectPage";
import SearchPage from "@/pages/SearchPage";
import SettingsPage from "@/pages/SettingsPage";
import SharedProjectPage from "@/pages/SharedProjectPage";
import SharedFilePage from "@/pages/SharedFilePage";

function RootRedirect() {
    const { user } = useAuth();
    if (user === null) return null;
    return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<RootRedirect />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<Navigate to="/login" replace />} />
                        <Route path="/s/:token" element={<SharedProjectPage />} />
                        <Route path="/f/:token" element={<SharedFilePage />} />
                        <Route
                            path="/dashboard"
                            element={
                                <ProtectedRoute>
                                    <DashboardPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/customers"
                            element={
                                <ProtectedRoute>
                                    <CustomersPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/customers/:customerId"
                            element={
                                <ProtectedRoute>
                                    <CustomerDetailPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/projects/:projectId"
                            element={
                                <ProtectedRoute>
                                    <ProjectPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/search"
                            element={
                                <ProtectedRoute>
                                    <SearchPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/settings"
                            element={
                                <ProtectedRoute>
                                    <SettingsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster richColors position="top-right" />
            </AuthProvider>
        </div>
    );
}

export default App;
